import React from 'react'
import Linkify from 'react-linkify';

export const ImagineLinkify = ({ newTab = true, children }) => {

  const componentNewTab = (href, text, key) => (
    <a style={{ wordWrap: 'break-word' }} href={href} key={key} target="_blank" rel="noopener noreferrer" >
      {text}
    </a>
  );
  
  const component = (href, text, key) => (
    <a style={{ wordWrap: 'break-word' }} href={href} key={key}>
      {text}
    </a>
  );

  return (
    <Linkify componentDecorator={newTab ? componentNewTab : component }>
      { children }
    </Linkify>
  )
}
